import { atom } from 'jotai';

/**
 * Atom to control the collapsed state of the transcription panel
 * This is used across components to synchronize the collapsed state
 */
export const transcriptionCollapsedAtom = atom<boolean>(true);
